import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';

import {
    ServerErrorAction,
    ActionTypes,
    ServerMessageAction,
    ServerSuccessAction,
} from './toast.actions';
import { ToastService } from '../../services/toast.service';

@Injectable()
export class ToastEffects {
    serverError$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<ServerErrorAction>(ActionTypes.SERVER_ERROR),
                tap((action) => {
                    this._toastService.createAlert({ message: action.payload });
                })
            ),
        { dispatch: false }
    );

    serverSuccess$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<ServerSuccessAction>(ActionTypes.SERVER_SUCCESS),
                map((action) => action.payload)
            ),
        { dispatch: false }
    );

    serverMessage$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType<ServerMessageAction>(ActionTypes.SERVER_MESSAGE),
                tap((action) => {
                    this._toastService.create({
                        type: 'info-light',
                        message: action.payload,
                    });
                })
            ),
        { dispatch: false }
    );

    /**
     *
     * @param _actions$
     * @param _toastService
     */
    constructor(
        private _actions$: Actions,
        private _toastService: ToastService
    ) {}
}
